if(typeof window !== 'undefined'){
require('./core/core.js');
require('./core/core__draggable.js');
require('./theme/theme.js');
require('./topnav/topnav.js');
require('./topnav/topnav__title.js');
require('./topnav/topnav__connection.js');
require('./topnav/topnav__tabbutton.js');
require('./tab/tab.js');
require('./tab/tab__subnav.js');
require('./tab/tab__subnav__group.js');
require('./tab/tab__subnav__group__tool.js');
require('./tab/tab__subnav__group__toggle_button.js');
require('./dashboard/dashboard.js');
require('./inspector/inspector.js');
require('./inspector/inspector__group.js');
require('./inspector/inspector__modalbox.js');
require('./inspector/inspector__colorpicker.js');
require('./inspector/inspector__colorpicker__swatchrow.js');
require('./inspector/inspector__colorpicker__swatch.js');
require('./inspector/inspector__textinput.js');
require('./inspector/inspector__button.js');
require('./inspector/inspector__label.js');
require('./inspector/inspector__valueunit.js');
require('./inspector/inspector__valueunitfixed.js');
require('./inspector/inspector__valueunitcheck.js');
require('./inspector/inspector__readonly.js');
require('./inspector/inspector__checkbox.js');
require('./inspector/inspector__selectbox.js');
require('./inspector/inspector__slider.js');
require('./inspector/inspector__slider_advanced.js');
require('./inspector/inspector__commoncontrols.js');
require('./inspector/inspector__commoncontrols__button.js');
require('./window/window.js');
require('./window/window__listitem.js');
require('./tray/tray.js');
require('./tray/tray__tabs.js');
require('./tray/tray__tab__title.js');
require('./tray/tray__tab__button.js');
require('./tray/tray__tab__search.js');
require('./split/split.js');
require('./switcher/switcher.js');
require('./editorHolder/editorHolder.js');
require('./toolbar/toolbar.js');
require('./toolbar/toolbar__tool.js');
require('./library/library.js');
require('./master/master.js');

module.exports.Core = require('./core/core.js'); //allow to write custom templates outside ui-templates

var Modal = require('./modal/modal.js');
module.exports.Modal = Modal;
window.Modal = Modal;

var ModalList = require('./modal/modal__list.js');
module.exports.ModalList = ModalList;
window.ModalList = ModalList;

var Processing = require('./processing/processing.js');
module.exports.Processing = Processing;

var Throbber = require('./throbber/throbber.js');
module.exports.Throbber = Throbber;

var Splashscreen = require('./splashscreen/splashscreen.js');
module.exports.Splashscreen = Splashscreen;

var WarningBanner = require('./banner/warning_banner.js');
module.exports.WarningBanner = WarningBanner;

var Tooltip = require('./tooltip/tooltip.js');
module.exports.Tooltip = Tooltip;
window.Tooltip = Tooltip;

var Tray = require('./tray/tray.js');
module.exports.Tray = Tray;

module.exports.Master = require('./master/master.js');
module.exports.Sidebar = require('./sidebar/sidebar.js')
module.exports.InspectorGroup = require('./inspector/inspector__group.js');
module.exports.InspectorModalBox = require('./inspector/inspector__modalbox.js');

var LayoutCircuits = require('./master/master__circuits.js');
module.exports.LayoutCircuits = LayoutCircuits;

var LayoutTinkercad = require('./master/master__tinkercad.js');
module.exports.LayoutTinkercad = LayoutTinkercad;

// debug
window.LayoutCircuits = LayoutCircuits;
window.LayoutTinkercad = LayoutTinkercad;
}